import classNames from 'helpers/class-names'
import { FC, ReactNode } from 'react'

interface Props {
  breadcrumbs: ReactNode
  button?: ReactNode
  menu?: ReactNode
  children: ReactNode
  className?: string
}

const Header: FC<Props> = ({
  breadcrumbs,
  button = null,
  menu = null,
  children,
  className = '',
}) => (
  <header data-cy="page-header" className={classNames(className)}>
    <div className="flex sm:items-center">
      <div className="flex flex-1 flex-col">
        <div className="pb-5">{breadcrumbs}</div>
        <h1 className="-mt-2 hidden break-all pb-8 pl-2 font-body text-xl font-bold leading-7 text-gray sm:block md:-mb-2.5 md:mt-0">
          {children}
        </h1>
      </div>
      {button && (
        <div className="flex-0 -mt-5 flex items-center sm:ml-2 sm:mt-1">
          {button}
        </div>
      )}
      {menu && (
        <div className="flex-0 -mr-1 -mt-3 ml-2 flex items-center sm:mr-0 sm:mt-2.5">
          {menu}
        </div>
      )}
    </div>
    <h1 className="-mt-2 block w-full break-all py-4 pl-2 font-body text-xl font-bold leading-7 text-gray sm:hidden md:-mb-2.5 md:mt-0">
      {children}
    </h1>
  </header>
)

export default Header
